import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFireDatabase } from '@angular/fire/database';
import { AngularFireStorage } from '@angular/fire/storage';
import { AngularFirestore, DocumentData } from '@angular/fire/firestore';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { FirebaseAppConfig } from '@angular/fire';
import { AngularFirestoreCollection } from '@angular/fire/firestore/collection/collection';
import { AngularFirestoreDocument } from '@angular/fire/firestore/document/document';
import { Action, DocumentChangeAction, DocumentSnapshot, QueryFn } from '@angular/fire/firestore/interfaces';
import { Observable } from 'rxjs';
import * as firebase from 'firebase/app';
import { User } from 'firebase/app';

import { AOFirebaseFactoryService } from './ao-firebase-factory.service';
import { AOFirebaseConnectionService } from './ao-firebase-connection.service';

@Injectable({
  providedIn: 'root'
})
export class AOFirebaseService {

  protected _name = 'master';

  constructor(
    private _firebase: AOFirebaseFactoryService,
  ) {
  }

  firebase(): AOFirebaseFactoryService {
    return this._firebase;
  }

  factory(configs: FirebaseAppConfig): Promise<boolean> {
    return this._firebase.factory(this.name(), configs);
  }

  conn(): AOFirebaseConnectionService {
    return this._firebase.conn(this.name());
  }

  name() {
    return this._name;
  }

  hash() {
    return this.conn().hash();
  }

  app() {
    return this.conn().app();
  }

  // -------------------------------------------------------------------------------------------------------------------

  auth(): AngularFireAuth {
    return this.conn().auth();
  }

  authState(): Observable<User | null> {
    return this.auth().authState;
  }

  // -------------------------------------------------------------------------------------------------------------------

  db(): AngularFireDatabase {
    return this.conn().database();
  }

  dbNow() {
    return firebase.database.ServerValue.TIMESTAMP;
  }

  // -------------------------------------------------------------------------------------------------------------------

  fs(): AngularFirestore {
    return this.conn().firestore();
  }

  fsId(): string {
    return this.fs().createId();
  }

  fsDoc<T>(path: string): AngularFirestoreDocument<T> {
    return this.fs().doc(path);
  }

  fsDocValue(path: string): Observable<DocumentData | undefined> {
    return this.fsDoc(path).valueChanges();
  }

  fsDocSnapshot(path: string): Observable<Action<DocumentSnapshot<DocumentData>>> {
    return this.fs().doc(path).snapshotChanges();
  }

  fsDocSet(path: string, data: any, options = {merge: true}): Promise<void> {
    return this.fs().doc(path).set(data, options);
  }

  fsCol<T>(path: string, queryFn?: QueryFn): AngularFirestoreCollection<T> {
    return this.fs().collection(path, queryFn);
  }

  fsColValues(path: string, queryFn?: QueryFn): Observable<DocumentData[]> {
    return this.fsCol(path, queryFn).valueChanges();
  }

  fsColSnapshot(path: string, queryFn?: QueryFn): Observable<DocumentChangeAction<DocumentData>[]> {
    return this.fsCol(path, queryFn).snapshotChanges();
  }

  fsColState(path: string, queryFn?: QueryFn): Observable<DocumentChangeAction<DocumentData>[]> {
    return this.fsCol(path, queryFn).stateChanges();
  }

  fsBatch() {
    return this.fs().firestore.batch();
  }

  fsNow() {
    return firebase.firestore.FieldValue.serverTimestamp();
  }

  fsTimestamp() {
    return firebase.firestore.Timestamp;
  }

  // fsToMilliseconds(item, field) {
  //   if (item[field] instanceof Timestamp) {
  //     item[field] = (new Date(item[field].seconds * 1000 + item[field].nanoseconds / 1000000)).getTime();
  //   }
  // }

  // fsAddMilliseconds(date) {
  //   date.milliseconds = (new Date(date.seconds * 1000 + date.nanoseconds / 1000000)).getTime();
  //   return date;
  // }

  // fsTransaction<T>(updateFunction: (transaction: firebase.firestore.Timestamp) => Promise<T>): Promise<T> {
  //   return this.fs().firestore.runTransaction(updateFunction);
  // }

  // fsCounter(path, field = 'count', qt = 1) {
  //   return this.fsTransaction(transaction => {
  //     const ref = this.fsDoc(path).ref;
  //     return transaction.get(ref).then((doc) => {
  //
  //       const update = {};
  //
  //       if (doc.exists) {
  //         const value = parseInt(doc.get(field), 10);
  //         qt = value >= 0 || value <= 0 ? qt + value : qt;
  //       }
  //
  //       update[field] = qt;
  //
  //       transaction.set(ref, update, {merge: true});
  //
  //     });
  //   });
  // }

  // fsUp(path, field = 'count') {
  //   return this.fsCounter(path, field, 1);
  // }

  // fsDown(path, field = 'count') {
  //   return this.fsCounter(path, field, -1);
  // }

  // -------------------------------------------------------------------------------------------------------------------

  msn(): AngularFireMessaging {
    return this.conn().messaging();
  }

  // -------------------------------------------------------------------------------------------------------------------

  disk(): AngularFireStorage {
    return this.conn().storage();
  }

  // fsLinkFree(bucket, path) {
  //   return 'https://firebasestorage.googleapis.com/v0/b/' + bucket + '/o/' + path.split('/').join('%2F') + '?alt=media';
  // }

  // async fsUpload(file, configs): Promise<any> {
  //   const now = new Date();
  //   const extension = /(?:\.([^.]+))?$/;
  //   const data: any = {};
  //
  //   data.id = this.fsId();
  //   data.md5 = (await AOUtil.md5File(file)) as string;
  //   data.extension = (extension.exec(file.name)[1]).toLowerCase();
  //   data.name = file.name.substr(0, file.name.length - data.extension.length - 1);
  //   data.size = file.size;
  //   data.mimetype = file.type;
  //   data.modified_at = file.lastModified;
  //   data.folder = '/' + ['files', now.getUTCFullYear(), now.getUTCMonth() + 1, now.getUTCDate()].join('/');
  //   data.path = data.folder + '/' + data.id + '.' + data.extension;
  //   data.active = true;
  //   data.created_at = this.fsNow();
  //   data.updated_at = null;
  //   data.deleted_at = null;
  //
  //   if (configs.types && configs.types.indexOf(data.mimetype) == -1) {
  //     throw new Error('Tipo InvÃ¡lido: ' + file.name);
  //   }
  //   if (configs.extensions && configs.extensions.indexOf(data.extension) == -1) {
  //     throw new Error('ExtensÃ£o invÃ¡lida: ' + file.name);
  //   }
  //   if (configs.size && configs.size < data.size) {
  //     throw new Error('Muito grande: ' + file.name);
  //   }
  //
  //   const snapshot = <any>await this.fsCol('/files', q => q.where('md5', '==', data.md5).limit(1)).get().toPromise();
  //   if (configs.duplicate === false && snapshot.docs.length > 0) {
  //     throw new Error('JÃ¡ existe: ' + file.name);
  //   }
  //
  //   return new Promise((resolve, reject) => {
  //
  //     if (snapshot.docs.length > 0) {
  //       return resolve(snapshot.docs[0].data());
  //     }
  //
  //     const task = this.storage().upload(data.path, file);
  //
  //     task.then(snapshot => {
  //       data.metadata = AOUtil.undefinedToNull(Object.assign({}, snapshot.metadata));
  //       this.fsDoc('/files/' + data.id).set(data).then(() => {
  //         return resolve(data);
  //       });
  //     });
  //
  //   });
  // }

  // uploader(): AOFirebaseUploaderService {
  //   return new AOFirebaseUploaderService(this);
  // }

}
